/**************************************************
 * Nombre:       PorMayor_Ventajas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import empa from '../../../Recursos/empananda.svg'
import {useFormulario} from "../../../Modulo_formularios/Hooks/useFormulario";
import {iniciarChatWass} from "../../../Utilidades/iniciarChatWass";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const PorMayor_Ventajas = () => {
    const {sCell} = useResponsive()
    const {props} = useFormulario({valoresDefecto: {}})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >


                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography
                                sx={{
                                    fontFamily: NEGRITA,
                                    fontSize: 32,
                                    color: theme.palette.primary.main,
                                    textAlign: sCell ? 'center' : 'left',
                                    lineHeight: 1.2
                                }}>
                                ventajas de adquirir la franquicia
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                            <Typography sx={{fontSize: 18, fontWeight: 600, textAlign: sCell ? 'center' : 'left'}}>
                                Nuestra franquicia te ofrece la oportunidad de gestionar un negocio probado, con
                                respaldo de una marca consolidada, procesos eficientes y un producto que enamora a
                                todos. Sé parte de un proyecto que combina tradición, calidad y pasión por la
                                gastronomía local.
                            </Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 4}}
                        >

                            {items.map((item, index) => (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                    <Typography sx={{fontWeight: 600}}> <span>
                                                <img src={empa} width={25} height={'auto'}
                                                     style={{marginTop: 6, marginBottom: -6, paddingRight: 5}}/>
                                            </span> {item}</Typography>
                                </Grid>
                            ))}

                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 6}}>
                            <Button
                                onClick={() => iniciarChatWass({mensaje: 'Hola quiero mas informacion de la franquicia'})}
                            >Mas informacion</Button>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default PorMayor_Ventajas

const items = [
    'Marca reconocida',
    'Soporte integral',
    'Productos exclusivos',
    'Modelo probado'
]